// client/src/hooks/usePlataformaBranding.js
// Logo da própria plataforma (SituAI) — exibida na sidebar de QUALQUER
// usuário logado (matriz/franquia/conta), mas só matriz pode trocar/remover.
// Espelha usePlataformaNotaFiscal.js (mesmo namespace /plataforma/*).
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

export const usePlataformaBranding = () => useQuery({
    queryKey: ['plataforma-branding'],
    queryFn: () => apiClient.get('/plataforma/branding').then((r) => r.data.data),
    staleTime: 5 * 60 * 1000,
});

// variant: 'light' (fundo claro, texto grafite) | 'dark' (fundo escuro, texto branco)
export const useUploadPlataformaBranding = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: ({ file, variant }) => {
            const formData = new FormData();
            formData.append('file', file);
            return apiClient.put(`/plataforma/branding/${variant}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-branding'] });
            setAlert('Logo da plataforma atualizada com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao enviar a logo da plataforma.'), 'danger'),
    });
};

export const useRemovePlataformaBranding = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (variant) => apiClient.delete(`/plataforma/branding/${variant}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-branding'] });
            setAlert('Logo da plataforma removida.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao remover a logo da plataforma.'), 'danger'),
    });
};
